import React from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import { PrimaryButton } from "../../../elements/Button";
import I18nText from "../../../elements/I18nText";
import LoadingOverlay from "../../../elements/LoadingOverlay";
import Row from "./Row";
import NoData from "./NoData";
import { useAuth, PERMISSIONS } from "../../../auth";

const List = React.memo(
  ({
    device,
    records,
    maintenanceLimit,
    isLoading,
    onCreate,
    onEdit,
    onDelete
  }) => {
    const { hasPermission } = useAuth();
    const canManage = hasPermission(
      device.permissions,
      PERMISSIONS.MAINTENANCE
    );
    const limitReached = records.length >= maintenanceLimit;

    return (
      <>
        {canManage && (
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                textAlign: "right",
                marginBottom: 16
              }}
            >
              <Tooltip
                title={
                  limitReached ? (
                    <I18nText values={{ limit: maintenanceLimit }}>
                      devices.maintenance.limitReached
                    </I18nText>
                  ) : (
                    ""
                  )
                }
              >
                <span>
                  <PrimaryButton
                    onClick={onCreate}
                    icon={<AddIcon />}
                    disabled={limitReached}
                  >
                    <I18nText>devices.maintenance.actions.new</I18nText>
                  </PrimaryButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        )}

        {isLoading ? (
          <LoadingOverlay isLoading minHeight={200} />
        ) : records.length === 0 ? (
          <NoData />
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <I18nText>devices.maintenance.table.header.title</I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>devices.maintenance.table.header.priority</I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>
                    devices.maintenance.table.header.technician
                  </I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>
                    devices.maintenance.table.header.startDate
                  </I18nText>
                </TableCell>
                <TableCell align="right">
                  <I18nText>
                    devices.maintenance.table.header.intervalDays
                  </I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>
                    devices.maintenance.table.header.nextDueAt
                  </I18nText>
                </TableCell>
                <TableCell>
                  <I18nText>devices.maintenance.table.header.status</I18nText>
                </TableCell>
                <TableCell
                  style={{
                    minWidth: 75
                  }}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {records.map(record => (
                <Row
                  key={record.id}
                  device={device}
                  record={record}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))}
            </TableBody>
          </Table>
        )}
      </>
    );
  }
);

export default List;
